import React, { createContext, useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import { socketClient } from "../socket/socketClient";
import { User_Role } from "@shared/constants/api";

const SocketContext = createContext<typeof socketClient | null>(null);

export const SocketProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { token, user, isAuthenticated } = useSelector((state: any) => state.auth);

    useEffect(() => {
        if (isAuthenticated && token) {

            const socket = socketClient.connect(token);


            if (socket) {
                socket.on("connect", () => {
                    if (user?.role?.toUpperCase() === User_Role.curator) {
                        socketClient.emit("user-online", user.id);
                    }
                });

                if (socket.connected && user?.role?.toUpperCase() === User_Role.curator) {
                    socketClient.emit("user-online", user.id);
                }
            }
        } else {
            socketClient.disconnect();
        }

        return () => {
            socketClient.disconnect();
        };
    }, [isAuthenticated, token, user?.id, user?.role]);

    return (
        <SocketContext.Provider value={socketClient}>
            {children}
        </SocketContext.Provider>
    );
};

export const useSocket = () => {
    const context = useContext(SocketContext);
    if (!context) {
        throw new Error("useSocket must be used within a SocketProvider");
    }
    return context;
};
